import axios from "axios";
import { SERVER_URL } from "../config";
const FileSaver = require('file-saver');

export const savePlanInputs = (advisorId, payload, token) => {

  console.log("savePlanInputs");

  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/api/ifw/client`;

    axios
      .post(targetUrl, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        resolve(response);
      });
  });
};

export const login = (email, password) => {
  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/api/ifw/login`;

    const payload = {
      email: email,
      password: password,
    };

    axios
      .post(targetUrl, payload)
      .then((response) => {
        if (response.data.hasOwnProperty("accessToken")) {
          resolve(response.data);
        }
        reject(response.data.errors[0])
      })
      .catch((error) => {
        console.log('login -> something went wrong')
        reject('Something went wrong');
      });
  });
};

export const getUserInfo = (token) => {
  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/api/ifw/user-info`;

    axios
      .get(targetUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        resolve(response.data);
      });
  });
};

export const getUserList = (token) => {
  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/api/ifw/admin-info`;

    axios
      .get(targetUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        resolve(response.data);
      });
  });
};

export const getFinancialProfessionalList = (token) => {
  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/api/ifw/admin-fp`;

    axios
      .get(targetUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        resolve(response.data);
      });
  });
};

export const getConciergeFinancialProfessionals = (id, token) => {
  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/api/ifw/admin-fp-conceirge/${id}`;

    axios
      .get(targetUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        resolve(response.data);
      });
  });
};

export const createUser = (userData, token) => {
  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/api/ifw/admin-create-clients`;

    axios
      .post(targetUrl, userData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        resolve(response.data);
      }).catch(e => console.log(e, "createUser"))
  });
};

export const updateUser = (userData, token) => {
  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/api/ifw/admin-update-ifwuser`;

    axios
      .post(targetUrl, userData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        resolve(response.data);
      }).catch(e => console.log(e, "EditUser"))
  });
};

export const getFinancialProfessionalClients = (token) => {
  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/api/ifw/client-list`;

    axios
      .get(targetUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        resolve(response.data);
      });
  });
};

export const getSuperAdminClientList = (fpId, token) => {
  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/api/ifw/admin-fp-clients?fp_id=${fpId}`;

    axios
      .get(targetUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        resolve(response.data);
      });
  });
};

export const publishPlan = (clientId, token) => {

  console.log("publishPlan");

  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/api/ifw/client/${clientId}/base-plan`;

    axios
      .post(
        targetUrl,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        resolve(response);
      });
  });
};

export const getPlanCashFlowApi = (clientId, token) => {
  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/api/ifw/client/${clientId}/base-plan/cash-flow`;
    axios
      .get(targetUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        resolve(response.data);
      });
  });
};

export const getPlanFutureCashFlowApi = (clientId, token) => {
  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/api/ifw/client/${clientId}/future-plan/cash-flow`;
    axios
      .get(targetUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        resolve(response.data);
      }).catch(e => resolve([]))
  });
};

export const saveFuturePlanRoadmap = (clientId, token) => {

  console.log("saveFuturePlanRoadmap");

  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/api/ifw/client/${clientId}/future-plan`;

    axios
      .post(targetUrl, null, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        resolve(response);
      })
      .catch((e) => console.log(e, "saveFutureRoad"));

  });
};

export const saveAdjustments = (clientId, payload, token) => {
  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/api/ifw/client/${clientId}/adjustments`;

    axios
      .post(targetUrl, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        resolve(response.data);
      });
  });
};

export const getAdjustments = (clientId, token) => {
  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/api/ifw/client/${clientId}/adjustments`;
    axios
      .get(targetUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        resolve(response.data);
      });
  });
};


export const generatePDF = (html, clientId, token) => {
  return new Promise((resolve, reject) => {

    const targetUrl = `${SERVER_URL}/api/ifw/client/${clientId}/generate-pdf?time=${(new Date()).getTime()}`
    const content = `<!DOCTYPE html>${html}`;

    axios
      .post(targetUrl, content, {
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then(function (response) {
        resolve(response)
      })
  });
}


export const getClientList = (advisorId, token) => {
  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/api/ifw/advisor/${advisorId}/client-list`;

    axios
      .get(targetUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        resolve(response.data);
      });
  });
};

export const getClient = (clientId, token) => {
  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/api/ifw/client/${clientId}`;

    axios
      .get(targetUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        resolve(response);
      });
  });
};

export const deleteClient = (clientId, token) => {
  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/api/ifw/client/${clientId}/delete`;

    axios.post(targetUrl, {}, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
        .then((response) => {
            resolve(response);
        });
  });
}

export const forgotPassword = (email) => {
  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/api/ifw/login/forgot-password?email=${encodeURIComponent(email)}`;
    axios
      .post(targetUrl)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response.data.errors[0]);
      });

  });
};

export const signOff = (token) => {
  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/api/ifw/login/signoff`;
    axios
      .post(targetUrl, null, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};


export const getQuestionsPlanInput = (token) => {
  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/api/ifw/questions`;

    axios
      .get(targetUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        resolve(response);
      });
  });
};

export const updateUserEmail = (userId, email, token) => {
  return new Promise((resolve, reject) => {
    axios.post(`${SERVER_URL}/api/ifw/user/change-user-email`, {
      newEmail: email,
      userId: userId
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then(response => {
      resolve({});
    });
  });
};

export const resetUserPassword = (userId, token) => {
  return new Promise((resolve, reject) => {
    axios.post(`${SERVER_URL}/api/ifw/user/reset-password`, {
      userId: userId
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      resolve({});
    });
  });
};

export const lockUser = (userId, token) => {
  return new Promise((resolve, reject) => {
    axios.post(`${SERVER_URL}/api/ifw/user/lock`, {
      userId: userId,
      lock: true
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then(() => {
      resolve({});
    });
  });
};

export const unLockUser = (userId, token) => {
  return new Promise((resolve, reject) => {
    axios.post(`${SERVER_URL}/api/ifw/user/lock`, {
      userId: userId,
      lock: false
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then(() => {
      resolve({});
    });
  });
};

export const isEmailAddressDuplicated = (email, token) => {
  return new Promise((resolve, reject) => {
    const encodedEmail = encodeURIComponent(email);
    axios.post(`${SERVER_URL}/api/ifw/user/check-duplicate-email?email=${encodedEmail}`, null, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      const result = response.data;
      resolve(result.includes("already"));
    });
  });
};

export const changePassword = async (currentPassword, newPassword, token) => {
  console.log("My Access Token: ", token);
  try {
    await axios.post(`${SERVER_URL}/api/ifw/user/change-current-password`, {
      currentPassword: currentPassword,
      newPassword: newPassword
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    });

    return true;

  } catch {
    return false;
  }

};

export const getRILAHistoricReturns = (token) => {
  return new Promise((resolve, reject) => {
    axios.get(`${SERVER_URL}/api/ifw/sandp500-historic-return`, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      resolve(response.data);
    });
  });
}

export const getInsurancePolicies = async (token) => {
  try {
    const response = await axios.get(`${SERVER_URL}/api/ifw/insurance-policies`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching insurance policies', error);
    throw error;
  }
}

export const getUsageReportRecipients = async (token) => {

  try {
    const response = await  axios.get(`${SERVER_URL}/api/ifw/usage-report/recipients`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    return response.data;

  } catch (error) {
    console.log("Error fetching usage report recipients");
    throw error;
  }

};

export const updateUsageReportRecipients = async (emailList, token) => {
  try {
    const response = await  axios.post(`${SERVER_URL}/api/ifw/usage-report/recipients`, {
      userEmails: emailList
    },{
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    return response.data;

  } catch (error) {
    console.log("Error fetching usage report recipients");
    throw error;
  }
}


export const downloadUsageReport = async (startDate, endDate, token) => {
  try {
    const response = await  axios.get(`${SERVER_URL}/api/ifw/usage-report/download/${startDate}/${endDate}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    return response.data;

  } catch (error) {
    console.log("Error fetching usage report recipients");
    throw error;
  }
};

export const sendUsageReport = async (emailList, startDate, endDate, token) => {
  try {
    const response = await  axios.post(`${SERVER_URL}/api/ifw/usage-report/send`, {
      userEmails: emailList,
      startDate: startDate,
      endDate: endDate
    },{
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    return response.data;

  } catch (error) {
    console.log("Error fetching usage report recipients");
    throw error;
  }
};

/*

GET:

GET:

/api/ifw/client/1250/future-plan-wizard

{
    "id": 1,
    "planOptimizationType": "BALANCED",
    "annuityAllocation": 60.00,
    "balanced": 30.00
}


POST:

/api/ifw/client/1250/future-plan-wizard

{
    "id": 1,
    "planOptimizationType": "BALANCED",
    "annuityAllocation": 60.00,
    "balanced": 30.00
}

 */

export const getFuturePlanWizardSettings = async (clientId, token) => {
  try {
    const response = await  axios.get(`${SERVER_URL}/api/ifw/client/${clientId}/future-plan-wizard`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    return response.data;

  } catch (error) {
    console.log("Error fetching usage report recipients");
    throw error;
  }
}

export const saveFuturePlanWizardSettings = async (clientId, settings, token) => {
  try {
    const response = await  axios.post(`${SERVER_URL}/api/ifw/client/${clientId}/future-plan-wizard`, settings, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    return response.data;

  } catch (error) {
    console.log("Error fetching usage report recipients");
    throw error;
  }
}
